module.exports = __webpack_public_path__ + "static/flags/MG-dd8cb1bf681c57d2d3de9e35afe92441.gif";